import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;
export const AccountDetailAr_UnpaidInvoiceFieldsFragmentDoc = gql`
  fragment AccountDetailAr_UnpaidInvoiceFields on OrderInvoice {
    due_at
    invoice_id
    unpaid_amount_in_micros
  }
`;
export const AccountDetailAr_CreditMemoFieldsFragmentDoc = gql`
  fragment AccountDetailAr_CreditMemoFields on CreditMemo {
    credit_amount_in_micros
    credit_id
  }
`;
export const SalesPortalAccountDetailArDocument = gql`
  query SalesPortalAccountDetailAr(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
    $usableAfter: String
  ) {
    getAvailableCreditMemosByCustomer(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
      usable_after: $usableAfter
    ) {
      credit_memos {
        ...AccountDetailAr_CreditMemoFields
      }
      restaurant_id
    }
    getUnpaidOrderInvoicesByCustomer(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
    ) {
      order_invoices {
        ...AccountDetailAr_UnpaidInvoiceFields
      }
      restaurant_id
      supplier_id
    }
  }
  ${AccountDetailAr_CreditMemoFieldsFragmentDoc}
  ${AccountDetailAr_UnpaidInvoiceFieldsFragmentDoc}
`;
export function useSalesPortalAccountDetailArQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalAccountDetailArQuery,
    Types.SalesPortalAccountDetailArQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalAccountDetailArQuery,
    Types.SalesPortalAccountDetailArQueryVariables
  >(SalesPortalAccountDetailArDocument, options);
}
export function useSalesPortalAccountDetailArLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalAccountDetailArQuery,
    Types.SalesPortalAccountDetailArQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalAccountDetailArQuery,
    Types.SalesPortalAccountDetailArQueryVariables
  >(SalesPortalAccountDetailArDocument, options);
}
export type SalesPortalAccountDetailArQueryHookResult = ReturnType<
  typeof useSalesPortalAccountDetailArQuery
>;
export type SalesPortalAccountDetailArLazyQueryHookResult = ReturnType<
  typeof useSalesPortalAccountDetailArLazyQuery
>;
export type SalesPortalAccountDetailArQueryResult = Apollo.QueryResult<
  Types.SalesPortalAccountDetailArQuery,
  Types.SalesPortalAccountDetailArQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalAccountDetailArQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalAccountDetailArQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalAccountDetailArQuery,
    Types.SalesPortalAccountDetailArQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalAccountDetailArQuery,
    Types.SalesPortalAccountDetailArQueryVariables
  >(SalesPortalAccountDetailArDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalAccountDetailArLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalAccountDetailArLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalAccountDetailArQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalAccountDetailArQuery,
    Types.SalesPortalAccountDetailArQueryVariables
  >(SalesPortalAccountDetailArDocument, lazyOptions);
}
